import { IApplicationState } from 'app/types/types';
import { connect } from 'react-redux';
import { ICardColorTagsActionEvents, ICardColorTagsActionFields } from '../components/types';
import { ICardColorTagsActionHOCProps } from './types';
import { CardColorTagsAction } from '../components/CardColorTagsAction';
import { getCardActionsColorTagsCreateSelector } from './selectors/getCardActionsColorTags';
import { onToggleColorTag } from './events/onToggleColorTag';
import { getBoardIdByCardId } from '../../../../../../../store/model/selectors/getBoardIdByCardId';

const mapStateToProps = () => {
    const getCardActionsColorTags = getCardActionsColorTagsCreateSelector();

    const _mapStateToProps = (
        state: IApplicationState,
        { cardId }: ICardColorTagsActionHOCProps
    ): ICardColorTagsActionFields => {
        const boardId = getBoardIdByCardId(state, cardId);
        return {
            colorTags: getCardActionsColorTags(state, boardId, cardId),
        };
    };

    return _mapStateToProps;
};

const mapDispatchToProps = (
    dispatch: any,
    { cardId, openColorTags }: ICardColorTagsActionHOCProps
): ICardColorTagsActionEvents => {
    return {
        onToggleColorTag: (colorTagId) => dispatch(onToggleColorTag(cardId, colorTagId)),
        openColorTags,
    };
};

export const CardColorTagsActionHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(CardColorTagsAction);

CardColorTagsActionHOC.displayName = 'CardColorTagsActionHOC';
